import { callApi } from 'loankeeper-common/api'

export const details = ({ ID, hash, page, additionalParams }) =>
  callApi('application_view', {
    params: {
      AppID: ID,
      HashSum_AppID_: hash,
      page,
      ...additionalParams,
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const print = (params) =>
  callApi('application_view', {
    params,
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

// export const dmqueue = (params) =>
//   callApi('dm_queue', {
//     params,
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const changeEssence = ({ action, AppID, HashSum_AppID_, ClientID, HashSum_ClientID_, ...rest }) =>
//   callApi('application_add', {
//     params: {
//       action,
//       AppID,
//       HashSum_AppID_,
//       ClientID,
//       HashSum_ClientID_,
//     },
//     body: rest,
//     method: 'post',
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const add = (params) => changeEssence({ action: 'add', ...params })

// export const edit = (params) => changeEssence({ action: 'edit', ...params })

// export const deleteIt = (params) => changeEssence({ action: 'delete', ...params })

// export const search = (params) =>
//   callApi('application_search', {
//     params,
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const updateAgreementNumber = (AppID, hash, AgreementNo) =>
//   callApi('application_oper', {
//     params: {
//       AppID,
//       HashSum_AppID_: hash,
//       AgreementNo,
//       action: 'agreementnumberupdate',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const addPermission = (ID, AppID, hash) =>
//   callApi('application_oper', {
//     params: {
//       AppID,
//       HashSum_AppID_: hash,
//       action: 'accesspermadd',
//       ID,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const deletePermission = (ID, AppID, hash) =>
//   callApi('application_oper', {
//     params: {
//       AppID,
//       HashSum_AppID_: hash,
//       action: 'accesspermdelete',
//       ID,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const expireApplication = (ID, hash) =>
//   callApi('application_oper', {
//     params: {
//       AppID: ID,
//       HashSum_AppID_: hash,
//       action: 'expire',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const undoExpireApplication = (ID, hash) =>
//   callApi('application_oper', {
//     params: {
//       AppID: ID,
//       HashSum_AppID_: hash,
//       action: 'expireundo',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const undoToScreening = (ID, hash) =>
//   callApi('application_oper', {
//     params: {
//       AppID: ID,
//       HashSum_AppID_: hash,
//       action: 'undotoscreening',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const rejectScreening = (ID, AppID, hash) =>
//   callApi('application_oper', {
//     params: {
//       AppID,
//       HashSum_AppID_: hash,
//       action: 'screeningreject',
//       ID,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const rejectScreeningUndo = (AppID, hash) =>
//   callApi('application_oper', {
//     params: {
//       AppID,
//       HashSum_AppID_: hash,
//       action: 'screeningrejectundo',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const returnToReview = (AppID, AppHash, Comment) =>
//   callApi('application_oper_post', {
//     params: {
//       AppID,
//       HashSum_AppID_: AppHash,
//       action: 'return',
//     },
//     body: { Comment },
//     method: 'post',
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const sendToCommittee = (AppID, AppHash, Comment) =>
//   callApi('application_oper_post', {
//     params: {
//       AppID,
//       HashSum_AppID_: AppHash,
//       action: 'send',
//     },
//     body: { Comment },
//     method: 'post',
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const custEeItems = (params) => {
//   const { STK, ItemCode, ProductID, TermDays, Sale } = params
//   return callApi('cust_ee_items', {
//     params: {
//       STK,
//       ItemCode,
//       ProductID,
//       TermDays,
//       Sale,
//       action: 'find',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })
// }

// export const dmProcess = (ID, hash) =>
//   callApi('application_oper', {
//     params: {
//       AppID: ID,
//       HashSum_AppID_: hash,
//       action: 'dmprocess',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })
